export const GAME_VERSION = '0.4.52';
/**
 * The replay-input manifest digest this version was cut with — the recorded value of
 * `CAMPAIGN_V2_COMBAT_CONTENT_DIGEST_COMPUTED` (campaignV2ReplayInputs.ts), which hashes every data
 * input the headless replay reads to decide a clear's outcome. `campaignV2CombatContentDigest.test.ts`
 * fails when the two differ: any combat-content edit must bump GAME_VERSION and restamp this in the
 * same change, so an in-flight clear is refused as `client_outdated` at the session pin instead of
 * failing replay verification later (docs/STAT_SHEETS_DESIGN.md §5.2).
 */
export const CAMPAIGN_V2_COMBAT_CONTENT_DIGEST = 'sha256:5764764be6b88c818b0720d0a5c865090f5648cc22de5f36042ac57cfabcac21';
const COMBAT_CONTENT_DIGEST_PREFIX = 'sha256:';
const COMBAT_CONTENT_DIGEST_PIN_HEX_CHARS = 12;
/**
 * The replay pin: the release version together with the combat content it was cut with. A stage
 * session, a recorded clear timeline and the server's compatibility gate all carry this instead of
 * `GAME_VERSION`, so editing combat content without a release bump still invalidates every in-flight
 * session as `client_outdated` — the digest guard above cannot be satisfied silently. Run summaries
 * are not replay pins and keep plain `GAME_VERSION`.
 */
export const CAMPAIGN_V2_CONTENT_VERSION = `${GAME_VERSION}+${CAMPAIGN_V2_COMBAT_CONTENT_DIGEST.slice(COMBAT_CONTENT_DIGEST_PREFIX.length, COMBAT_CONTENT_DIGEST_PREFIX.length + COMBAT_CONTENT_DIGEST_PIN_HEX_CHARS)}`;
